var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuniperChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.251051.49391c.334735-.334735.877449-.334735 1.212179 0L12 11.0307 22.5368.49391c.3347-.334735.8774-.334735 1.2121 0 .3348.334735.3348.87745 0 1.21218L13.214 12.241c-.1549.162-.3408.2914-.5466.3805-.2107.0912-.4378.1382-.6674.1382-.2296 0-.4567-.047-.6674-.1382-.2058-.0891-.3917-.2185-.5466-.3805L.251051 1.70609c-.3347348-.33473-.3347348-.877445 0-1.21218Z",
    fill: "#133F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniperChevronDown);
export default __webpack_public_path__ + "static/media/juniper-chevron-down.4f5306f9454d55824dc03d26172ee501.svg";
export { ForwardRef as ReactComponent };